































import Vue from 'vue'
import { PostCodeData } from '@/model/addresses/PostCodeData'
import { DxColumn, DxDataGrid, DxScrolling } from 'devextreme-vue/data-grid'

interface ComponentData {
  focusedRowKey: number
  selectedRow: PostCodeData | undefined
}

export default Vue.extend({
  name: 'PostCodeDialog',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    postCodeData: Array as () => PostCodeData[]
  },

  data (): ComponentData {
    return {
      focusedRowKey: 0,
      selectedRow: undefined
    }
  },

  methods: {
    onFocusedRowChanged (e: any): void {
      this.selectedRow = e.row.data
    },

    onKeyDown (e: any): void {
      if(e.event.key === "Enter" && this.selectedRow) {
        this.$emit('save', this.selectedRow)
      }
    },

    rowDblClick(event: any): void {
      this.$emit('save', event.data)
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    contentReady(e: any): void {
      e.component.focus()
    }
  }
})
